module.exports = __webpack_public_path__ + "static/media/YM72_6.3f84522c.jpg";